<template>
<div id="transferManage">
  <div class="search">
    <div class="searchInline">
      <el-input v-model="searchParams.Numbering" placeholder="友途卡编号" clearable></el-input>
    </div>
    <div class="searchInline">
      <el-input v-model="searchParams.phonenumber" placeholder="请输入用户手机号" clearable></el-input>
    </div>
    <div class="searchInline">
      <el-input v-model="searchParams.Name" placeholder="请输入用户姓名" clearable></el-input>
    </div>
    <div class="searchInline">
      <el-select v-model="searchParams.status" @change="submitSearch" placeholder="请选择双签状态" clearable>
        <el-option label="退订" :value="0"></el-option>
        <el-option label="正常" :value="1"></el-option>
        <el-option label="欠费" :value="2"></el-option>
        <el-option label="账户变更/未绑定" :value="3"></el-option>
        <el-option label="关注状态停发" :value="4"></el-option>
      </el-select>
    </div>
    <div class="searchInline">
      <el-input v-model="searchParams.isAccount" placeholder="请选择车辆品牌" clearable></el-input>
    </div>
    <div class="searchInline">
      <el-date-picker
          v-model="searchParams.createTimes"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          @change="submitSearch"
          clearable>
        </el-date-picker>
    </div>
    <div class="searchInline">
      <el-select v-model="searchParams.activation" @change="submitSearch" placeholder="是否激活" clearable>
        <el-option label="未激活" :value="0"></el-option>
        <el-option label="已激活" :value="1"></el-option>
      </el-select>
    </div>
    <div class="searchInline">
      <el-button type="primary" @click="submitSearch()">搜索</el-button>
    </div>
    <div class="searchInline">
      <el-button type="primary" @click="searchClear(1)">清除</el-button>
    </div>
  </div>
  <div class="search" style="background: #f2f2f2;height: 50px;"><div class="prompt"><i class="el-icon-info"></i>已选择<span style="color: #409EFF;font-weight: 700;margin-left: 5px;margin-right: 5px;">{{selectuser}}</span>项 建议每次总数量不大于100项<span style="color: #409EFF;font-weight: 600;margin-left: 15px;" @click="cleara">清空</span></div>
    <div class="Createevent" v-if="this.multipleSelection.length > 0"><el-button type="primary" @click="createevent1">创建任务</el-button></div>
  </div>
  <div class="contentView">
    <el-table ref="multipleTable" :data="tableData"  style="width: 100%" :row-key="getRowKeys1" @selection-change="handleSelectionChange">
      <el-table-column
        type="selection" width="55" :reserve-selection="true">
      </el-table-column>
      <el-table-column
        label="友途卡编号"
        width="120">
        <template slot-scope="scope">{{ scope.row.cardid }}</template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        width="120">
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="vehNum"
        label="车牌号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="clsbh"
        label="车辆识别码"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="vehBrand"
        label="车辆品牌"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="vehRecordDate"
        label="车辆注册时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="signStatus"
        label="双签状态"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="signDate"
        label="开卡时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="name"
        label="激活状态"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.sd == 1">已激活</span>
          <span v-if="scope.row.sd == null || scope.row.sd == 0">未激活</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="操作"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="to_able" @click="userdetails(scope.row)">详情</span>
          <span class="to_able" @click="openCall(scope.row)">呼叫</span>
          <span class="to_able" @click="dialogShow()">绑定逸创客服</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="sizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10,20,30,40]"
        :page-size="searchParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalResult">
      </el-pagination>
    </div>
    <el-dialog title="绑定逸创云客服账号" :visible.sync="dialog.submit.show" width="500px">
      <el-form :model="dialog.submit" label-width="100px">
        <el-form-item label="用户名">
          <el-input style="width:250px;" v-model="dialog.submit.userName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input style="width:250px;" v-model="dialog.submit.password" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog.submit.show = false">取 消</el-button>
        <el-button type="primary" @click="bindCall">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</div>
</template>

<script>
import { devCode } from '@/http/baseUrl';
export default {
  name: 'transferManage',
  data () {
    return {
      searchParams: {
        Numbering: '',
        phonenumber: '',
        Name: '',
        isAccount: '',
        period: '',
        status: '',
        activation: '',
        frequency: '',
        createTimes: '',
        time: [],
        ffTime: [],
        pageSize: 10,
        pageIndex: 0
      },
      ids: '',
      value1: '',
      currentPage: 1,
      totalResult: 0,
      totalPage: 0,
      tableData: [],
      multipleSelection: [],
      selectuser: 0,
      formLabelWidth: '',
      selectStoreIds1: [],
      dialog: {
        submit: {
          show: false,
          userName: '',
          password: ''
        }
      }
    };
  },
  created () {
    this.vehicleBrands();
    this.getList();
  },
  methods: {
    // 车辆品牌
    vehicleBrands () {
      console.log(this.searchParams.isAccount);
      this.axios.get('/doubleTask/brande' + devCode, {
        params: {
          grade: 1,
          brand: this.searchParams.isAccount
        }
      }).then(res => {
        console.log(res);
        if (res.data.isSuccess) {
          // this.tableData = res.data.resultData.pageListData;
          // this.totalResult = res.data.resultData.totalResult;
          // this.totalPage = res.data.data.totalPage;
        };
      });
    },
    // 获取列表数据
    getList () {
      if (this.searchParams.status === 0) {
        this.searchParams.status = '退订';
      } else if (this.searchParams.status === 1) {
        this.searchParams.status = '正常';
      } else if (this.searchParams.status === 2) {
        this.searchParams.status = '欠费';
      } else if (this.searchParams.status === 3) {
        this.searchParams.status = '账户变更/未绑定';
      } else if (this.searchParams.status === 4) {
        this.searchParams.status = '关注状态停发';
      }
      this.axios.get('/doubleTask/pageList' + devCode, {
        params: {
          sd: this.searchParams.activation, // 激活
          name: this.searchParams.Name || '', // 用户名
          cardid: this.searchParams.Numbering || '', // 友途卡编号
          mobile: this.searchParams.phonenumber || '', // 手机号
          vehBrand: this.searchParams.isAccount || '', // 车辆品牌
          checkTimeBegin: this.searchParams.createTimes ? this.searchParams.createTimes[0] : '', // 查询开始时间
          checkTimeEnd: this.searchParams.createTimes ? this.searchParams.createTimes[1] : '', // 查询结束时间
          signStatus: this.searchParams.status || '',
          pageIndex: this.searchParams.pageIndex,
          pageSize: this.searchParams.pageSize
        }
      }).then(res => {
        console.log(res);
        if (res.data.isSuccess) {
          this.tableData = res.data.resultData.pageListData;
          this.totalResult = res.data.resultData.totalResult;
          // this.totalPage = res.data.data.totalPage;
        };
      });
    },
    // 搜索列表
    submitSearch () {
      console.log(this.searchParams);
      this.searchParams.pageIndex = 0;
      this.getList();
      this.vehicleBrands();
      this.currentPage = 1;
    },
    // 搜索列表
    submitSearch1 () {
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 清除
    searchClear (num) {
      if (num === 1) {
        this.clearListSearch();
      } else if (num === 2) {
        this.clearListSearch2();
        this.getUserList();
      }
    },
    // 清除列表的搜索表单
    clearListSearch () {
      this.searchParams = {
        mobile: '',
        Name: '',
        isAccount: '',
        time: [],
        ffTime: [],
        status: '',
        pageSize: 10,
        pageIndex: 0
      };
      this.getList();
    },
    // 更改pageSize
    sizeChange (val) {
      this.searchParams.pageSize = val;
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 跳页
    handleCurrentChange (val) {
      this.searchParams.pageIndex = val - 1;
      this.getList();
    },
    openCall (obj) {
      console.log(obj);
      let param = {
        number: obj.mobile
      };
      // https://{yourdomain}.kf5.com/voice/outbound
      this.axios
        .post(`/doubleTask/outbound`, param)
        .then(res => {
          if (res.data.isSuccess) {
            this.$message.success(res.data.message);
          } else {
            this.$message.warning(res.data.message);
          }
        });
    },
    dialogShow () {
      this.dialog.submit.show = true;
      this.dialog.submit.userName = '';
      this.dialog.submit.password = '';
    },
    bindCall () { // 呼叫失败需要录入客服账号
      if (this.dialog.submit.userName === '' || this.dialog.submit.password === '') {
        this.$message.warning('用户名或密码不能为空');
      } else {
        let param = {
          kf5Name: this.dialog.submit.userName,
          kf5Pwd: this.dialog.submit.password
        };
        this.axios
          .post(`/doubleTask/bindKf5Info`, param)
          .then(res => {
            if (res.data.isSuccess) {
              this.$message.success(res.data.message);
              this.dialog.submit.show = false;
            } else {
              this.$message.warning(res.data.message);
            }
          });
      }
    },
    // 去查看详情
    userdetails (val) {
      this.$router.push({
        name: 'customerCheck', query: { mobile: val.mobile }
      });
    },
    // 获取选中的
    handleSelectionChange (val) {
      this.multipleSelection = val;
      this.selectuser = this.multipleSelection.length;
    },
    getRowKeys1 (row) {
      return row.id;
    },
    cleara () {
      this.$refs.multipleTable.clearSelection();
    },
    submitConfirm () {
      this.axios({
        url: `/agentAwardBatch/transfer` + devCode,
        method: 'post',
        data: {
          ids: this.ids
        }
      }).then(res => {
        if (res.data.ok) {
          this.$message.success(res.data.data);
          this.dialog.submit.show = false;
          this.getList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createevent1 () {
      let obj = '';
      this.multipleSelection.forEach(item => {
        obj += item.mobile + ',';
      });
      this.newList = obj.substring(0, obj.length - 1);
      this.$router.push({name: 'addTask', query: {table: this.newList, fromUrl: 'jianhangUser'}});
    }
  }
};
</script>
<style lang="scss">
.el-table th div.renderHeader{
  line-height: 14px; padding: 0; margin-top: 4px;
  span{margin-right: 5px;}
  i{cursor: pointer;}
}
.chosen{width: 100%;height: 50px;background: #ffffff;}
.prompt{float: left;line-height: 34px;font-size: 14px;}
.Createevent{float: right;}
.el-icon-info{margin-left: 15px;margin-right: 15px;}
</style>



// WEBPACK FOOTER //
// src/components/jianhangUser/index.vue